import { Pipe, PipeTransform } from '@angular/core';
import { assertUnreachable } from '@evorait/pace-core';
import { FormListEntryState } from '../../../types/form-list';
import { FormsConstants } from '../../../types/forms-constants';
import SUBMIT_STATUS = FormsConstants.SUBMIT_STATUS;

@Pipe({
    name: 'formListEntryCssClass',
    standalone: false,
})
export class FormsListEntryCssClassPipe implements PipeTransform {
    public transform(value: FormListEntryState): string {
        let css = '';
        switch (value.type) {
            case FormsConstants.FORMTYPE.MAINTENANCE:
            case FormsConstants.FORMTYPE.SAFETY:
            case FormsConstants.FORMTYPE.TRAININGCHECKLIST:
            case FormsConstants.FORMTYPE.PREINSTALLATION_REPORT:
            case FormsConstants.FORMTYPE.INSTALLATION_REPORT:
            case FormsConstants.FORMTYPE.INSTALLATION_STARTUP_REPORT:
            case FormsConstants.FORMTYPE.STARTUP_REPORT:
            case FormsConstants.FORMTYPE.SOFTWARE_HANDLING_REPORT:
            case FormsConstants.FORMTYPE.TUNE_UP_REPORT:
            case FormsConstants.FORMTYPE.QUALITY_ASSURANCE_REPORT:
            case FormsConstants.FORMTYPE.DISASSEMBLY_REPORT:
            case FormsConstants.FORMTYPE.RECONDITIONING_REPORT:
            case FormsConstants.FORMTYPE.CUSTOMER_ACCEPTANCE_REPORT:
            case FormsConstants.FORMTYPE.COMMISSIONING_REPORT:
            case FormsConstants.FORMTYPE.MAINTENANCE_REPORT:
            case FormsConstants.FORMTYPE.SAFETY_RELATED_TEST_REPORT:
            case FormsConstants.FORMTYPE.APPLICATION_TRAINING_REPORT:
            case FormsConstants.FORMTYPE.PRE_TRAINING_CLARIFICATION_REPORT:
            case FormsConstants.FORMTYPE.TROUBLESHOOTING_REPORT:
            case FormsConstants.FORMTYPE.REPLACEMENT_REPORT:
            case FormsConstants.FORMTYPE.ADJUSTMENT_REPORT:
            case FormsConstants.FORMTYPE.CONFIGURATION_REPORT:
            case FormsConstants.FORMTYPE.SAFETY_INFORMATION_REPORT:
            case FormsConstants.FORMTYPE.DISPOSAL_REPORT:
            case FormsConstants.FORMTYPE.SITE_PLANNING_REPORT:
            case FormsConstants.FORMTYPE.UPGRADE_REPORT:
            case FormsConstants.FORMTYPE.UPDATE_REPORT:
            case FormsConstants.FORMTYPE.UNKNOWN:
                css = `type-${value.type}`;
                break;
            default:
                assertUnreachable(value.type);
        }

        if (
            [
                SUBMIT_STATUS.FINAL,
                SUBMIT_STATUS.FINAL_NOT_OK,
                SUBMIT_STATUS.INTERIM,
                SUBMIT_STATUS.INTERIM_NOT_OK,
                SUBMIT_STATUS.HANDOVER,
            ].includes(value.submitStatus) ||
            (value.submitStatus === SUBMIT_STATUS.REFRESHED && value.isOldVersion) ||
            value.previousSubmit
        ) {
            css += ' dimmed';
        }

        if (value.isOldVersion) {
            css += ' old-version';
        }

        return css;
    }
}
